// extracted by mini-css-extract-plugin
export default {"log":"styles_log__U5hky","log__title":"styles_log__title__3-Wv4","log__dateTime":"styles_log__date-time__kP89T"};